import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import AuthService from '../../services/AuthService';
import PartnerService from '../../services/PartnerService';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class PartnerListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new PartnerService());
        this.state = {
            list: [],
            loading: true,
            hideFilters: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
        };
        this.authService = new AuthService();
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria.locale,
            name: criteria.name,
            email: criteria.email,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            name: undefined,
            email: undefined,
            locale: this.authService.getI18n(),
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return t('partner.listTitle');
    }
    getCriteriaName() {
        return 'partner-list-sc';
    }

    getContainerListName() {
        return 'partner-list-container';
    }
    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    label={t('partner.name')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    placeholder={t('list.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaTextComponent
                    id='email-sc'
                    name='email'
                    label={t('partner.email')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.email}
                    placeholder={t('list.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
            </div>
        );
    }

    imageBodyTemplate(rowData) {
        return (
            <img
                src={`${new PartnerService().getPath()}/logo/${rowData.logoUuid}?token=${new AuthService().getToken()}`}
                alt='Avatar'
                className='product-image'
                style={{borderRadius: '50%', height: '40px', width: '50px'}}
            />
        );
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.authService.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('partner.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {
                field: 'id',
                header: t('ID'),
                sortable: true,
            },
            {
                field: 'name',
                header: t('partner.name'),
                sortable: true,
            },
            {
                field: 'email',
                header: t('partner.email'),
                sortable: true,
            },
            {field: 'image', header: t('partner.logo'), body: this.imageBodyTemplate},

            {
                key: 'actions',
                header: t('global.action'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    //override
    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/`+sessionStorage.getItem('i18nextLng');
        return (
            <div>
                <ActionLink
                    rendered={this.backLinkRendered}
                    className='p-link float-right'
                    handleClick={this.handleGoToDetail.bind(this, detailHref)}
                    variant='blue'
                    iconName='mdi-pen'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
            </div>
        );
    }

    breadCrumbItems() {
        return [{name: t('partner.listTitle'), url: '/partner-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

PartnerListContainer.defaultProps = {
    detailUrl: '/partner/details',
    newUrl: '/partner/create',
    editUrl: '/partner/edit',
    lazy: true,
};

PartnerListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(PartnerListContainer));
